import * as React from 'react';

export const programData = [
  {
    title: 'Развитие зрительной памяти',
    description:
      <>
        <p>Узнаете, как раз и навсегда запоминать любую информацию.</p>
        <p>Научитесь пользоваться абстрактным мышлением для запоминания.</p>
      </>
  },
  {
    title: 'Развитие зрительной памяти, запоминание списков',
    description:
      <>
        <p>Научитесь запоминать новые слова с помощью созвучных ассоциаций на примере валют разных стран.</p>
        <p>Поймете, как запоминать списки слов, а также имена и фамилии людей.</p>
      </>
  },
  {
    title: 'Запоминание иностранных слов',
    description:
      <p>Поймете, как быстро запоминать новые иностранные слова на примере турецкого, корейского, английского языков.</p>
  },
  {
    title: 'Запоминание числовых данных',
    description:
      <p>Освоите технику для запоминания телефонных номеров, важных дат, данных банковских карт и любой другой информации, содержащей цифры.</p>
  },
  {
    title: 'Запоминание графической информации',
    description:
      <p>Научитесь запоминать географические карты, флаги, сложные формулы, схемы, лица людей, художественные картины и другую графическую информацию.</p>
  },
  {
    title: 'Запоминание текстов дословно',
    description:
      <p>Отработаете технологию быстрого дословного запоминания больших объемов текста.</p>
  },
  {
    title: 'Запоминание лиц и имен людей',
    description:
      <p>Сможете запоминать имена и лица большого количества незнакомых людей.</p>
  }
];
